import { createSelector } from 'reselect';

export const getCommentsFetching = state => state?.comments?.fetching;

export const getCommentsData = (state, entity, id) => {
    return state?.comments?.[entity]?.[id];
};

export default createSelector([getCommentsFetching, getCommentsData]);
